export enum GlobalTabsKeysEnum {
  marketData = 'Market Data',
  portfolioManagement = 'Portfolio Management',
  portfolioPerformance = 'Portfolio Performance',
  riskManagement = 'Risk Management',
  positions = 'Positions',
  transactions = 'Transactions',
  pnl = 'PNL',
  fundingRate = 'Funding Rate',
  pricing = 'Pricing',
  marketProbabilities = 'Market Probabilities',
  carryBasis = 'Carry & Basis',
  optionsFlow = 'Options Flow',
  settings = 'Settings',
  OTCTrader = 'OTC Trader',
  immersiveAI = 'Immersive AI',
  Admin = 'Admin',
  backtesting = 'Backtesting',
}

export type AppBarlink = {
  label: string;
  url: string;
  permissions?: string;
  allowed?: boolean;
};

export const appBarLinks: AppBarlink[] = [
  {
    label: GlobalTabsKeysEnum.marketData,
    url: '/dashboard',
    permissions: 'market_data',
    allowed: true,
  },
  {
    label: GlobalTabsKeysEnum.portfolioManagement,
    url: '/portfolio-management',
    permissions: 'risk',
    allowed: true,
  },
  {
    label: GlobalTabsKeysEnum.portfolioPerformance,
    url: '/portfolio-performance',
    permissions: 'risk',
    allowed: true,
  },
  {
    label: GlobalTabsKeysEnum.OTCTrader,
    url: '/otc-trader',
    permissions: 'otc-trader',
    allowed: true,
  },
  {
    label: GlobalTabsKeysEnum.pricing,
    url: '/dashboard/pricing',
    permissions: 'market_data',
    allowed: true,
  },
  {
    label: GlobalTabsKeysEnum.marketProbabilities,
    url: '/dashboard/market-probabilities',
    permissions: 'market_data',
    allowed: true,
  },
  {
    label: GlobalTabsKeysEnum.carryBasis,
    url: '/dashboard/carry-basis',
    permissions: 'market_data',
    allowed: true,
  },
  {
    label: GlobalTabsKeysEnum.optionsFlow,
    url: '/dashboard/options-flow',
    permissions: 'market_data',
    allowed: true,
  },
  // Backtesting is intentionally omitted from the nav on staging: the backtester
  // engine endpoint only runs on DEMO/PROD_OVH, so exposing the tab here would be
  // a dead feature. The page code, route (layout.tsx), enum member and
  // permission-mapping entry are retained so the codebase stays aligned with
  // development and reachable by direct URL, but no menu renders it. Re-add this
  // appBarLink entry if/when staging gains a working backtester backend.
  { label: GlobalTabsKeysEnum.Admin, url: '/admin', permissions: 'admin' },
  {
    label: GlobalTabsKeysEnum.immersiveAI,
    url: '/immersive-ai',
    permissions: 'immersive-ai',
  },
];
